var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{ref:"refQuillEditor",attrs:{"options":_vm.quillOptions},model:{value:(_vm.model.$model),callback:function ($$v) {_vm.$set(_vm.model, "$model", $$v)},expression:"model.$model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }